// extracted by mini-css-extract-plugin
export default {"default-templates__header":"DefaultTemplates_default-templates__header__QlXkO","default-templates__listbox-item":"DefaultTemplates_default-templates__listbox-item__Cf2aR"};